module.exports = __webpack_public_path__ + "img/uid-game-guide-1.a0ab30c0.png";